import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import loadingReducer from './loading/reducers/loadingReducer';
import authReducer from '../pages/auth/redux/reducers/authReducer';

const createReducer = asyncReducers => (
	combineReducers({
		loading: loadingReducer,
		auth: authReducer,
		router: routerReducer,
		...asyncReducers
	})
);

export default createReducer;
